import { render, staticRenderFns } from "./CompleteEarlyResolutionProcessErpInstructions.vue?vue&type=template&id=70049ade"
import script from "./CompleteEarlyResolutionProcessErpInstructions.vue?vue&type=script&lang=ts"
export * from "./CompleteEarlyResolutionProcessErpInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports